export const nutrients = {
    n: "N",
    p: "P",
    k: "K",
};
export const nutrientsFullName = {
    n: "N",
    p: "P2O5",
    k: "K2O",
};

export const HUNDRED = 100;
export const ZERO = 0;
export const NUTRIENTS_COUNT = 3;
export const NITROGEN_MAX_LIMIT = 46; //N
export const PHOSPHORUS_COUNT = 54; //P
export const POTASSIUM_MAX_LIMIT = 62; //K
export const NUTRIENTS_SUM_MAX_LIMIT = 62; //K
export const RECIPE_ITEMS_MAX_COUNT = 6;
export const RECIPE_ITEMS_MIN_COUNT = 1;
export const TWO = 2;
export const FIVE = 5;
export const ONE = 1;
export const DEALER_LINK = "https://www.haifa-group.com/search-distributor";
export const ABOUT_HAIFA_LINK = "https://www.haifa-group.com/about-us-0";
export const NO_VALUE_STRING = "N/A";
export const MIN_CELSIUS_VALUE = 9;
export const MAX_CELSIUS_VALUE = 35;
export const RATIO_TO_FERENHITE = 32;

export const links = {
    haifaFacebook: "https://www.facebook.com/HaifaGroup",
    haifaLinkedIn: "https://www.linkedin.com/company/haifa-group",
    zigitWebsite: "https://www.zigit.co.il",
    googleMaps: "https://maps.googleapis.com/maps/api/geocode/json?language=he&address=",
    logoHaifaGroup: "https://upload.wikimedia.org/wikipedia/commons/3/38/Haifa_Group_Logo.png",
    controlledReleaseFertilizer: "https://www.haifa-group.com/controlled-release-fertilizer",
};
